const B_1 = [
    {
        title: '评价',
        path: '/bidding/projectflow/dingbiao/evaluate/list'
    }
]
export default {
    path: 'evaluate',
    component: () => import(/*webpackChunkName: 'bidding-ding-cjyygl'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/evaluate/list'),
            meta: {
                title: '评价',
                bread: B_1
            },
        },
         {
             path:"form",
             component: () => import('@views/bidding/views/project-flow/ding/evaluate/components/form'),
             meta: {
                 title: '评价',
                 bread: B_1
             },
         },
    ]
}